<template>
  <div class="container-fluid px-0" id="header">
    <!--<img src="https://ticketorganizer.eu/cms/res/organizers/o3/organizer_header_lg_2x.jpg" id="header-background">-->
    <img src="../assets/header.png" id="header-background">
    <div class="header-gradiant"></div>
    <div class="container" id="header-content">
      <img src="../assets/ticketorganizer-logo--white.svg" alt="Ticketorganizer Logo" id="ticketorganizer-logo">
      <div id="details">
        <!--<img src="https://ticketorganizer.eu/cms/res/organizers/o3/organizer_logo.png" id="logo">-->
        <h1 class="text-center">Filmfest St. Anton Wahlabos</h1>

        <p><small>
          Fotocredit:
          MKM I Christoph Johann
          Rider: Nadine Wallner
        </small></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header"
}
</script>

<style scoped>
#header {
  height: 400px;
  overflow: hidden;
  color: #ffffff;
}
#header-background {
  width: 100%;
  height: 100%;
  display: block;
  -o-object-fit: cover;
  object-fit: cover;
}
.header-gradiant {
  width: 100%;
  height: 400px;
  position: absolute;
  top: 0;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  background: -webkit-gradient(linear, left top, left bottom, from(rgba(0, 0, 0, 0)), to(rgba(0, 0, 0, 0.8)));
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.8));
}
#header-content {
  position: absolute;
  top: 0;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
}
#ticketorganizer-logo {
  width: 160px;
  margin-top: 25px;
}
#details {
  /*margin-top: 75px;*/
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  z-index: 1;
  justify-content: space-between;
  min-height: 290px;
}
#header-content h1 {
  margin-top: 20px;
  font-size: 2.3rem;
  line-height: 1.1;
  font-weight: 900;
}

#logo {
  max-height: 150px !important;
}

@media (min-width: 768px) {
  #header-content h1 {
    font-size: 3.16667rem;
  }
}
</style>